export const getDateString = (isoDate) => {
    if (!isoDate) {
        return '';
    }
    const event = new Date(isoDate);
    const options = {year: 'numeric', month: 'long', day: 'numeric'};
    return event.toLocaleDateString('ja-JP', options);
};
